<template>
  <div>
    <van-cell-group inset>
      <van-cell title="总用户数" :value="businessData?.totalUsers ?? '-'" />
      <van-cell title="今日注册用户" :value="businessData?.todayRegisterUsers ?? '-'" />
      <van-cell title="总收益" :value="businessData?.totalEarn ?? '-'" />
      <van-cell title="今日收益" :value="businessData?.todayEarn ?? '-'" />
    </van-cell-group>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { getBusinessAnalysis } from '@/api/apiService';

const businessData = ref(null);

onMounted(async () => {
  try {
    const params = { code: 'sdfs232fa3f' }; // 替换为实际 code
    const res = await getBusinessAnalysis(params);
    businessData.value = res.businessAnalysisInfo;
  } catch (e) {
    businessData.value = { error: '获取数据失败' };
  }
});
</script>

  
  <style scoped>

  

  .page_container {
    display: flex;
    flex-direction: column;
    align-content: center;
    
  }

 

    
    
  .submit_title{
    font-size: 0.5rem;
    
    margin-bottom: 0.6rem;
    color: #0a0eeb;
    text-align: left;
    
  }
  .submit_main_body{
    font-size: 0.4rem;
    color:#848488;
    width: 100%;
    align-items: flex-start;
    margin-left: 1rem;
    margin-bottom: 0.2rem;
    
    text-align: left;
  }


  .submit_first_class_tilte{
    font-size: 0.4rem;
    color:#0606e6;
    width: 100%;
    align-items: flex-start;
    margin-left: 1rem;
    margin-top: 0.2rem;
    
    text-align: left;
  }







  </style>